<template>
  <div @click.stop="" class="col-md-12 col-xs-12 p-right-0">
    <confirmation-popup v-show="showMapBtn" title="Tracking map" :id="`map_${eonOptions.id}`" confirm-btn-text="Ok" :showCancelBtn="false" >
      <div rel="trackingMap" :id="eonOptions.id" class="contractor-tracking-map" v-show="mapLoaded" >
        <img src="/pic/image-loader.gif" class="center" width="40" v-show="show"/>
      </div>
    </confirmation-popup>

    <booking-view-scheduled-visit-timeline
        v-model="instances" :fieldworkerVisitStatus="fieldworkerVisitStatus"
        :is-running-late="isRunningLate" :visit="visit"
        :is-virtual="isVirtual"
    ></booking-view-scheduled-visit-timeline>
    <div v-show="showMapBtn" class="row" style="text-align: center">
      <a class="view-map" data-toggle="modal" :data-target="`map_${eonOptions.id}`" @click.stop="openTrackingMap" >
        View GPS tracking map
      </a>
    </div>

  </div>

</template>

<script>
import {EventBus} from "@/events/event-bus";
import {getVisitDetails} from "@/modules/Booking/api/visits"
import BookingViewScheduledVisitTimeline from "@/modules/Booking/components/visits/BookingViewScheduledVisitTimeline";

const STATUS_VISIT_ON_THE_WAY = 1
const STATUS_VISIT_ARRIVE_NOW = 2
const STATUS_VISIT_START_JOB = 3
const STATUS_VISIT_FINISH_JOB = 4
const STATUS_VISIT_JOB_DONE = 5
const STATUS_VISIT_RUNNING_LATE = 6
const STATUS_VISIT_JOB_MISSED = 7

const STATUS = {
  STATUS_VISIT_ON_THE_WAY: "On the way",
  STATUS_VISIT_ARRIVE_NOW: "Arrived",
  STATUS_VISIT_START_JOB: "Job Started",
  STATUS_VISIT_FINISH_JOB: "Job Finished",
  STATUS_VISIT_JOB_DONE: "Job Done",
  STATUS_VISIT_RUNNING_LATE: "Running Late",
  STATUS_VISIT_JOB_MISSED: "Job Missed"
}

require("leaflet")
require("eon-map")
const PubNub = require('pubnub')

export default {
  name: "BookingViewContractorTrackingMap",
  components: {BookingViewScheduledVisitTimeline},

  props: {
    value:{//status
      type: Object
    },
    isRunningLate: {
      type: Boolean,
      required: false,
      default: false
    },
    isVirtual: {
      type: Boolean,
      required: true,
      default: false
    },
    visit: {
      type: Object,
      required: false
    },
    fromPage:{
      type: String
    }
  },
  data() {
    return {
      eonOptions: {
        id: this.getRandomId(),
        pubnub: null,
        mbToken: null,
        channel: null,
        mbId: 'BOS',
        channels: [],
        connect: null,
        options: {
          center: null,
          zoom: 10,
          zoomAnimation: false
        }
      },
      instances: [],
      fieldworkerVisitStatus: this.value,
      map: null,
      show: true,
      mapLoaded: true,
      showMapBtn: false,
      refreshEvery: 5 // Refresh every 5 sec
    }
  },
  computed: {
    firstPoint() {
      if (this.instances.length > 0 && this.instances[0].locations.length > 0) {
        let location = this.instances[0].locations[0]
        return [location.lat, location.lon];
      }
      return [0, 0]
    }
  },
  methods: {
    init() {
      this.eonOptions.channel = this.getRandomChannelId();
      this.eonOptions.channels = [this.eonOptions.channel]
      this.eonOptions.pubnub = new PubNub({
        uuid: this.uuidv4(),
        publishKey: process.env.PUBNUMB_PUBLISH_KEY,
        subscribeKey: process.env.PUBNUMB_SUBSCRIBE_KEY
      })
      this.eonOptions.mbToken = process.env.EOP_MB_TOKEN
      this.eonOptions.options.center = this.firstPoint
      this.eonOptions.options.zoom = 11
      this.mapLoaded = true

      if (!this.map) {
        this.map = eon.map(this.eonOptions)
        this.drawLocations()
        this.show = false
      }
    },
    uuidv4() {
      return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c =>
          (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
      );
    },
    getRandomId() {
      let random = Math.floor(Math.random() * 199)
      return `tracking-map-${random}`
    },
    randDarkColor() {
      let lum = -0.25;
      let hex = String('#' + Math.random().toString(16).slice(2, 8).toUpperCase()).replace(/[^0-9a-f]/gi, '');
      if (hex.length < 6) {
        hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
      }
      let rgb = "#",
          c, i;
      for (i = 0; i < 3; i++) {
        c = parseInt(hex.substr(i * 2, 2), 16);
        c = Math.round(Math.min(Math.max(0, c + (c * lum)), 255)).toString(16);
        rgb += ("00" + c).substr(c.length);
      }
      return rgb;
    },
    drawLocations() {
      let vm = this;
      this.instances.forEach((instance, index) => {
        let points = instance.locations.map(location => [location.lat, location.lon])
        let line = L.polyline(points, {color: vm.randDarkColor()}).addTo(vm.map)

        line.bindPopup(instance.displayName)

        var greenIcon = new L.Icon({
          iconUrl: 'https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-green.png',
          shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/0.7.7/images/marker-shadow.png',
          iconSize: [25, 41],
          iconAnchor: [12, 41],
          popupAnchor: [1, -34],
          shadowSize: [41, 41]
        });

        var redIcon = new L.Icon({
          iconUrl: 'https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-red.png',
          shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/0.7.7/images/marker-shadow.png',
          iconSize: [25, 41],
          iconAnchor: [12, 41],
          popupAnchor: [1, -34],
          shadowSize: [41, 41]
        });

        if (instance.onTheWayLocation) {
          L.marker(instance.onTheWayLocation,{icon:redIcon}).addTo(vm.map).bindPopup(`On The Way : ${instance.timestamps.on_the_way}`)
        }
        if (instance.arrivedLocation) {
          L.marker(instance.arrivedLocation).addTo(vm.map).bindPopup(`Arrived : ${instance.timestamps.arrived}`)
        }
        if (instance.checkinLocation) {
          L.marker(instance.checkinLocation).addTo(vm.map).bindPopup(`Started : ${instance.timestamps.checkin}`)
        }
        if (instance.checkoutLocation) {
          L.marker(instance.checkoutLocation,{icon:greenIcon}).addTo(vm.map).bindPopup(`Finished : ${instance.timestamps.checkout}`)
        }
        if (instance.checkoutAutoLocation) {
          L.marker(instance.checkoutAutoLocation,{icon:greenIcon}).addTo(vm.map).bindPopup(`Auto Checkout (Finished) : ${instance.timestamps.checkout_auto}`)
        }

      })
    },
    getRandomChannelId() {
      return `pubnub-mapbox-vue-${this.getNonZeroRandomNumber()}`
    },
    getNonZeroRandomNumber() {
      let random = Math.floor(Math.random() * 199) - 99;
      if (random == 0) return this.getNonZeroRandomNumber();
      return random;
    },
    openTrackingMap(){
      $(`#map_${this.eonOptions.id}`).modal("show")
      this.init();
    }
  },
  mounted() {


      let vm = this;
          if (this.visit.tracking_details) {

            let data = this.visit.tracking_details
            for (let record of data) {
              this.instances.push({
                timestamps: record.timestamps,
                arrivedTime: record.arrived_time,
                checkinOutSameDate: record.check_in_out_same_date,
                checkinDate: record.checkin_date,
                estimatedTimeToFinish: record.estimate_time_to_finish == "0000-00-00 00:00:00" ? null : record.estimate_time_to_finish,
                estimatedTimeToArrive: record.estimate_time_to_arrive == "0000-00-00 00:00:00" ? null : record.estimate_time_to_arrive.toLowerCase(),
                checkinTime: record.checkin_time,
                checkoutDate: record.checkout_date,
                checkoutTime: record.checkout_time,
                displayName: record.display_name,
                finishedDate: record.finished_date,
                finishedTime: record.finished_time,
                isAutoCheckout: record.is_auto_checkout,
                autoCheckout: record.auto_checkout,
                locations: record.locations,
                onTheWayDistance: record.on_the_way_distance,
                onTheWayTime: record.on_the_way_time,
                visitDistance: record.visit_distance,
                visitId: record.visit_id,
                userId: record.user_id,

                checkinLocation: record.checkin_location,
                checkoutLocation: record.checkout_location,
                arrivedLocation: record.arrived_location,
                onTheWayLocation: record.on_the_way_location,
                checkoutAutoLocation: record.checkout_auto_location,
              })
              this.instances.forEach(function(instance,index){
                if(instance.arrivedTime)
                  instance.arrivedTime = instance.arrivedTime.replace(" am","am").replace(" pm","pm")
                if(instance.estimatedTimeToFinish)
                  instance.estimatedTimeToFinish = instance.estimatedTimeToFinish.replace(" am","am").replace(" pm","pm")
                if(instance.estimatedTimeToArrive)
                  instance.estimatedTimeToArrive = instance.estimatedTimeToArrive.replace(" am","am").replace(" pm","pm")
                if(instance.checkinTime)
                  instance.checkinTime = instance.checkinTime.replace(" am","am").replace(" pm","pm")
                if(instance.checkoutTime)
                  instance.checkoutTime = instance.checkoutTime.replace(" am","am").replace(" pm","pm")
                if(instance.autoCheckout)
                  instance.autoCheckout = instance.autoCheckout.replace(" am","am").replace(" pm","pm")
              })
              if(this.visit.accepted_at)
                this.visit.accepted_at = this.visit.accepted_at.replace(" am","am").replace(" pm","pm")

              if (record.checkout_date || record.checkin_date || record.arrived_time
              || record.on_the_way_time) {
                this.showMapBtn = true
              }
              vm.$nextTick(function(){
                if (record) {
                    setTimeout(function (e){    EventBus.$emit('titleConfirmationChange', record );
                        },1000)
                }
              })

          }
              EventBus.$emit("onTodayProcessLoaded")
          } else {
            vm.mapLoaded = false
          }
  },
  watch:{
    fieldworkerVisitStatus:{
      handler(status){
        this.$emit("input",status)//Affect changes to parent container
      },
      deep: true
    },
    value: {
      handler(status){

        this.fieldworkerVisitStatus = status
      },
    }
  }
}
</script>

<style scoped>
.contractor-tracking-map {
  height: 300px;
  width: 100%;
  top: 0;
  bottom: 0;
  position: relative;
}

.timeline-visit {
  margin-right: 50% !important;
}

.timeline-pane {
  margin-top: 10px;
}

.center {
  margin: 0;
  position: absolute;
  top: 50%;
  left: 50%;
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}
.view-map{
  color:#428bca;font-size:large
}
@media only screen and (max-width: 400px) {
  .timeline-visit {
    margin-right: 40% !important;
  }
}
</style>